import {
  NodeUtils,
  getAdapterAttributesString,
} from "@easy-email-pro-core/utils";
import React from "react";
import { BlockRenderer } from "./BlockRenderer";
import { ContentLeaf } from "./ContentLeaf";
import { ElementDefinition, HTML_NODE_VOID_TAGS } from "..";

export function BasicBlock(props: {
  params: Parameters<ElementDefinition["render"]>[0];
  tag: string;
  children?: React.ReactNode;
}) {
  const {
    params,
    params: { node, idx, children: children2, keepEmptyAttributes },
    tag,
    children,
  } = props;

  const content = children || children2;

  const formatAttribute = getAdapterAttributesString(params, {
    keepEmptyAttributes,
    removeDefaultAttributes: params.mode === "production",
    mode: params.mode,
  });

  if (HTML_NODE_VOID_TAGS.includes(tag)) {
    return <>{`<${tag} ${formatAttribute ? ` ${formatAttribute}` : ""} />`}</>;
  }
  const renderContent = (
    <>
      {`<${tag}${formatAttribute ? ` ${formatAttribute}` : ""}>`}
      {content ||
        node.children.map((child, index) => {
          if (NodeUtils.isTextNode(child)) {
            let text = child.text;
            if (index === 0) {
              text = text.replace(/^ {1}/g, "&nbsp;");
            }
            text = text.replace(/ {1}$/, "&nbsp;"); //最后一个空格替换为&nbsp;
            text = text.replace(/ {2}/g, " &nbsp;"); // 因为连续的实体空格会导致不能换行

            if (
              !text &&
              NodeUtils.isHTMLBlockNodeElement(node) &&
              tag.toLocaleLowerCase() === "div" &&
              node.children.length === 1
            ) {
              return "&nbsp;";
            }

            if (NodeUtils.isTextListElement(node)) {
              return (
                <React.Fragment key={index}>
                  {`<li>`}
                  <ContentLeaf
                    key={index}
                    {...params}
                    node={{ ...child, text }}
                  />
                  {`</li>`}
                </React.Fragment>
              );
            }
            return (
              <ContentLeaf key={index} {...params} node={{ ...child, text }} />
            );
          }
          return (
            <BlockRenderer
              key={index}
              {...params}
              idx={idx ? NodeUtils.getChildIdx(idx, index) : null}
              node={child}
            />
          );
        })}
      {`</${tag}>`}
    </>
  );

  return <>{renderContent}</>;
}
